import { getTheme } from "components/theme";
import { useUserPreferencesStore } from "core/store/RootStore";
import { observer } from "mobx-react-lite";
import { PropsWithChildren } from "react";

import { ThemeProvider } from "@mui/material";

export const AppThemeWrapper = observer(({ children }: PropsWithChildren) => {
  const { areToggledFeaturesVisible } = useUserPreferencesStore();
  return (
    <ThemeProvider theme={getTheme(areToggledFeaturesVisible)}>
      {children}
    </ThemeProvider>
  );
});
